import { toggleLoader } from './loader';
import { initializeModal } from './modalUtils';
import { sendEmail } from './sendEmail';
import { initializeValidation } from './formValidation';

const formDialog = document.getElementById('formDialog');
const formModal = document.getElementById('formModal');
const form = document.getElementById('formModal__form');
const inputs = form.querySelectorAll('input[required]');
const sendButton = document.getElementById('sendButton');
const openModalButtons = document.querySelectorAll('.open-modal-btn');
const closeModalButton = document.getElementById('close-modal-btn');

export const { openModal: openFormModal, closeModal: closeFormModal } =
  initializeModal(formDialog, formModal, closeModalButton, form);

export const { resetValidation } = initializeValidation(form, inputs);

openModalButtons.forEach(button => {
  button.addEventListener('click', openFormModal);
});

form.addEventListener('formValid', () => {
  toggleButton();
  toggleLoader();
  sendEmail();
});

formDialog.addEventListener('show', () => {
  resetValidation();
});

export const toggleButton = () => {
  sendButton.classList.toggle('button--hidden');
};

// Modal effects

// closeModalBtn.addEventListener('click', () => {
//   formDialog.querySelector('.modal').style.opacity = '0';
//   setTimeout(() => {
//     formDialog.close();
//   }, 250);
// });

// showModalBtn.addEventListener('click', () => {
//   formDialog.showModal();
//   formDialog.querySelector('.modal').style.opacity = '1';
// });
